module.exports = __webpack_public_path__ + "static/media/pic10.97f0e611.jpg";